import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import Month from '../assets/icons/custom/Month.svg?react';

export function MonthIcon(props: SvgIconProps) {
  return <SvgIcon component={Month} inheritViewBox {...props} />;
}
